<template>
   <div class="app-card" :class="customClasses">
      <v-card-text>
         <div class="layout justify-space-between pa-3">
            <div class="align-item-start">
               <h3 class="fw-bold mb-1">
                  <span v-if="isCash">$</span><countTo :startVal='0' :endVal="amount" :duration='1500' :decimals="isCash ? 2 : 0"></countTo>
               </h3>
               <p class="ma-0 fs-13 grey--text">{{heading}}</p>
            </div>
            <div class="align-item-end">
               <h3 class="dash-icon"><i :class="icon"></i></h3>
            </div>
         </div>
      </v-card-text>
      <slot></slot>
   </div>
</template>
<script>
    import countTo from "vue-count-to"

    export default {
    props: {
        heading: {
            type: String,
            required: true
        },
        amount: {
            type: Number,
            required: true
        },
        customClasses: {
            type: Object,
            required: false
        },
        icon: {
            type: String,
            required: false
        },
        isCash: {
            type: Boolean,
            required: false
        }
    },
    components: {
        countTo
    }
}
</script>
